module.exports = __webpack_public_path__ + "static/media/certified_badge_asird.370ac18a.png";